 $(document).ready(function(){
            $('.review-slider').slick({
                slidesToShow: 2,
                slidesToScroll: 1,
                centerMode: false,
                arrows: true,
              adaptiveHeight: true,
                dots: false,
              prevArrow: `<button type="button" class="slick-prev" aria-label="Previous">
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><g fill="none" stroke="#5f6352" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.7"><path d="m13.667 7.467l-3.778 3.777a1.134 1.134 0 0 0 0 1.606l3.778 3.683"/><path d="M12 21.5a9.5 9.5 0 1 0 0-19a9.5 9.5 0 0 0 0 19"/></g></svg>
  </button>`,
  nextArrow: `<button type="button" class="slick-next" aria-label="Next">
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><g fill="none" stroke="#5f6352" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.7"><path d="m10.333 16.533l3.778-3.778a1.133 1.133 0 0 0 0-1.605l-3.778-3.683"/><path d="M12 21.5a9.5 9.5 0 1 0 0-19a9.5 9.5 0 0 0 0 19"/></g></svg>
  </button>`,
                speed: 300,
                centerPadding: '2px',
                infinite: true,
                autoplaySpeed: 5000,
                autoplay: true,
                responsive: [
                {
                    breakpoint: 500,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1,
                        variableWidth: false,
                    },
                },
                {
                    breakpoint: 768,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1,
                    },
                },
                {
                    breakpoint: 992,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 1,
                    },
                },
                ],
            });
        });

 $(document).ready(function(){
            $('.review-slider-custom').slick({
                slidesToShow: 3,
                slidesToScroll: 1,
                centerMode: true,
                arrows: false,
                dots: false,
                speed: 300,
                centerPadding: '2px',
                infinite: true,
                autoplaySpeed: 5000,
                autoplay: true,
                responsive: [
                {
                    breakpoint: 500,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1,
                        variableWidth: true,
                    },
                },
                {
                    breakpoint: 768,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 1,
                    },
                },
                {
                    breakpoint: 992,
                    settings: {
                        slidesToShow: 3,
                        slidesToScroll: 1,
                    },
                },
                ],
            });
        });